import { useAuth } from '@/hooks/useAuth';
import { Template } from '@/components/organisms/layout/template';
import { AppRouters } from '@/utils/constants/routers';
import { useNavigate } from 'react-router-dom';
import { useEffect, ReactNode } from 'react';

interface PrivateRouteProps {
  children: ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate(AppRouters.login);
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) return null;
  if (!isAuthenticated) return null;

  return <Template>{children}</Template>;
};
